export default {
  getProduct: (state) => state.product,
};
